import t from 'utils/translationHelper';

import { PaymentOrigin } from '@alpha/payments-dtos';

const mapPaymentOrigin = (source: PaymentOrigin | undefined) => {
  switch (source) {
    case PaymentOrigin.ONLINE:
      return t('Portal');
    case PaymentOrigin.OFFLINE:
      return t('Offline');
    case PaymentOrigin.API:
      return 'API';
    case PaymentOrigin.SFTP:
      return 'SFTP';
    default:
      return '-';
  }
};

export default mapPaymentOrigin;
